import React from 'react';

interface BillingToggleProps {
  billingPeriod: 'monthly' | 'yearly';
  onBillingPeriodChange: (period: 'monthly' | 'yearly') => void;
}

export const BillingToggle: React.FC<BillingToggleProps> = ({
  billingPeriod,
  onBillingPeriodChange,
}) => {
  return (
    <div className="mt-8 flex justify-center">
      <div className="relative bg-white rounded-lg p-1 shadow-sm">
        <div className="flex">
          <button
            onClick={() => onBillingPeriodChange('monthly')}
            className={`px-6 py-2 text-sm font-medium rounded-md transition-colors ${
              billingPeriod === 'monthly'
                ? 'bg-blue-600 text-white'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => onBillingPeriodChange('yearly')}
            className={`px-6 py-2 text-sm font-medium rounded-md transition-colors ${
              billingPeriod === 'yearly'
                ? 'bg-blue-600 text-white'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Yearly
            <span className="ml-1.5 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
              Save 17%
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
